"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundValuesTable = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const SoundValuesTable_styles_1 = require("./SoundValuesTable.styles");
const SoundValuesTable = ({ items, infoMessage, translationEditHandler }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SoundValuesTable_styles_1.Wrapper, null, items.map((item, index) => (react_1.default.createElement(__1.SoundValueRow, { translationKey: item.translationKey, key: `${index}`, title: item.title, valueList: item.valueList, isHeader: index === 0, translationEditHandler: translationEditHandler })))),
        infoMessage && react_1.default.createElement(SoundValuesTable_styles_1.InfoMessageWrapper, null, infoMessage)));
};
exports.SoundValuesTable = SoundValuesTable;
//# sourceMappingURL=SoundValuesTable.js.map